/* eslint-disable @typescript-eslint/no-unused-vars */
import type { SearchAPIInterface } from './api-switcher'

type SearchQuery = {
  owner_id?: string
  in_user_id?: string
}

export const SearchAPI: SearchAPIInterface = {
  listOwners: (signal?: AbortSignal) =>
    // TODO: No direct API endpoint for listing owners
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  listInUsers: (signal?: AbortSignal) =>
    // TODO: No direct API endpoint for listing tagged users
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  searchAllPhotosDateWithId: (search: SearchQuery, desc: boolean, signal: AbortSignal) =>
    // TODO: No direct API endpoint for searching photo dates with IDs
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  searchPhotos: (
    search: SearchQuery,
    desc: boolean,
    offset: { date: Date, id: string },
    signal?: AbortSignal
  ) =>
    // TODO: No direct API endpoint for photo search with these filters
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  getPhotoFromSearch: (search: SearchQuery, photo_id: string, signal?: AbortSignal) =>
    // TODO: No direct API endpoint for getting photo from search context
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  tagsToSearchPhoto: (
    search: SearchQuery,
    photo_id: string,
    in_user_ids: string[]
  ) =>
    // TODO: No direct API endpoint for tagging in search context
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  reactionToSearchPhoto: (
    search: SearchQuery,
    photo_id: string,
    reaction: string,
    add: boolean
  ) =>
    // TODO: No direct API endpoint for reactions in search context
    Promise.resolve({
      error: { code: 0, message: 'Not implemented' },
      response: new Response()
    }),

  reportSearchPhoto: (search: SearchQuery, photo_id: string) => {
    console.log('reportSearchPhoto (not implemented)', search, photo_id)
    return Promise.resolve({
      error: {code: 501, message: 'Not Implemented'},
      response: new Response('', {status: 501})
    })
  }
}